<div class="p-inputgroup flex justify-space-around">
  <div class="flex justify-flex-start center input-group-container">
    <mat-radio-group [(ngModel)]="radioLeft">
      <mat-radio-button
        (click)="handleRadioClick(formPosition.Left)"
        [value]="field?.name + formPosition.Left"
        (keydown)="handleRadioClick(formPosition.Left)"
      ></mat-radio-button>
    </mat-radio-group>

    <ah-asset-field-input
      [autoFocus]="autoFocus"
      [autoSize]="autoSize"
      (change)="onChangeLeft($event)"
      [controlName]="field?.canonical_name + formPosition.Left"
            [disabled]="
                !enabledFieldTypes.includes(field?.type) ||
                disabledFields.includes(field?.canonical_name) ||
                !radioLeft
            "
      [field]="field"
      [filter]="filter"
      [fullWidth]="true"
      [group]="group"
            [options]="
                isPicklistField(field)
                    ? [makePicklistOption(field, formPosition.Left)]
                    : []
            "
      [placeholder]="placeholder"
      class="full-width-input-padding"
    ></ah-asset-field-input>
    <div class="checkbox-with-info">
      @if (field.canonical_name === 'cost') {
        <mat-checkbox
          class="sum-cost-checkbox"
          [checked]="sumTotalCostSelected"
          [disabled]="disableSumTotalCost"
          (change)="onSelectRowCheckbox($event)"
          >
          <span class="total-sum-label">SUM TOTAL COST</span>
        </mat-checkbox>
      }
      @if (field.canonical_name === 'cost' && disableSumTotalCost) {
        <mat-icon
          [matTooltip]="tooltipText"
          matTooltipPosition="right"
          class="info-icon"
          aria-label="Info"
          >
          info
        </mat-icon>
      }
    </div>
  </div>
  <div class="flex justify-flex-start center input-group-container">
    <mat-radio-group [(ngModel)]="radioRight">
      <mat-radio-button
        (click)="handleRadioClick(formPosition.Right)"
        [value]="field?.name + formPosition.Right"
        (keydown)="handleRadioClick(formPosition.Right)"
      ></mat-radio-button>
    </mat-radio-group>

    <ah-asset-field-input
      [autoFocus]="autoFocus"
      [autoSize]="autoSize"
      (change)="onChangeRight($event)"
      [controlName]="field?.canonical_name + formPosition.Right"
            [disabled]="
                !enabledFieldTypes.includes(field?.type) ||
                disabledFields.includes(field?.canonical_name) ||
                !radioRight
            "
      [field]="field"
      [filter]="filter"
      [fullWidth]="true"
      [group]="group"
            [options]="
                isPicklistField(field)
                    ? [makePicklistOption(field, formPosition.Right)]
                    : []
            "
      [placeholder]="placeholder"
      class="full-width-input-padding"
    ></ah-asset-field-input>
    <div class="checkbox-with-info">
      @if (field.canonical_name === 'cost') {
        <mat-checkbox
          class="sum-cost-checkbox"
          [checked]="sumTotalCostSelected"
          [disabled]="disableSumTotalCost"
          (change)="onSelectRowCheckbox($event)"
          >
          <span class="total-sum-label">SUM TOTAL COST</span>
        </mat-checkbox>
      }
      @if (field.canonical_name === 'cost' && disableSumTotalCost) {
        <mat-icon
          [matTooltip]="tooltipText"
          matTooltipPosition="right"
          class="info-icon"
          aria-label="Info"
          >
          info
        </mat-icon>
      }
    </div>
  </div>
  @if (combineAsset.length > 2) {
    <div
      class="flex justify-flex-start center input-group-container"
      >
      <mat-radio-group [(ngModel)]="radioThird">
        <mat-radio-button
          (click)="handleRadioClick(formPosition.Third)"
          [value]="field?.name + formPosition.Third"
          (keydown)="handleRadioClick(formPosition.Third)"
        ></mat-radio-button>
      </mat-radio-group>
      <ah-asset-field-input
        [autoFocus]="autoFocus"
        [autoSize]="autoSize"
        (change)="onChangeThird($event)"
        [controlName]="field?.canonical_name + formPosition.Third"
            [disabled]="
                !enabledFieldTypes.includes(field?.type) ||
                disabledFields.includes(field?.canonical_name) ||
                !radioThird
            "
        [field]="field"
        [filter]="filter"
        [fullWidth]="true"
        [group]="group"
            [options]="
                isPicklistField(field)
                    ? [makePicklistOption(field, formPosition.Third)]
                    : []
            "
        [placeholder]="placeholder"
        class="full-width-input-padding"
      ></ah-asset-field-input>
      <div class="checkbox-with-info">
        @if (field.canonical_name === 'cost') {
          <mat-checkbox
            class="sum-cost-checkbox"
            [checked]="sumTotalCostSelected"
            [disabled]="disableSumTotalCost"
            (change)="onSelectRowCheckbox($event)"
            >
            <span class="total-sum-label">SUM TOTAL COST</span>
          </mat-checkbox>
        }
        @if (field.canonical_name === 'cost' && disableSumTotalCost) {
          <mat-icon
            [matTooltip]="tooltipText"
            matTooltipPosition="right"
            class="info-icon"
            aria-label="Info"
            >
            info
          </mat-icon>
        }
      </div>
    </div>
  }
  @if (combineAsset.length > 3) {
    <div
      class="flex justify-flex-start center input-group-container"
      >
      <mat-radio-group [(ngModel)]="radioFourth">
        <mat-radio-button
          (click)="handleRadioClick(formPosition.Fourth)"
          [value]="field?.name + formPosition.Fourth"
          (keydown)="handleRadioClick(formPosition.Fourth)"
        ></mat-radio-button>
      </mat-radio-group>
      <ah-asset-field-input
        [autoFocus]="autoFocus"
        [autoSize]="autoSize"
        (change)="onChangeFourth($event)"
        [controlName]="field?.canonical_name + formPosition.Fourth"
            [disabled]="
                !enabledFieldTypes.includes(field?.type) ||
                disabledFields.includes(field?.canonical_name) ||
                !radioFourth
            "
        [field]="field"
        [filter]="filter"
        [fullWidth]="true"
        [group]="group"
            [options]="
                isPicklistField(field)
                    ? [makePicklistOption(field, formPosition.Fourth)]
                    : []
            "
        [placeholder]="placeholder"
        class="full-width-input-padding"
      ></ah-asset-field-input>
      <div class="checkbox-with-info">
        @if (field.canonical_name === 'cost') {
          <mat-checkbox
            class="sum-cost-checkbox"
            [checked]="sumTotalCostSelected"
            [disabled]="disableSumTotalCost"
            (change)="onSelectRowCheckbox($event)"
            >
            <span class="total-sum-label">SUM TOTAL COST</span>
          </mat-checkbox>
        }
        @if (field.canonical_name === 'cost' && disableSumTotalCost) {
          <mat-icon
            [matTooltip]="tooltipText"
            matTooltipPosition="right"
            class="info-icon"
            aria-label="Info"
            >
            info
          </mat-icon>
        }
      </div>
    </div>
  }
  @if (combineAsset.length > 4) {
    <div
      class="flex justify-flex-start center input-group-container"
      >
      <mat-radio-group [(ngModel)]="radioFive">
        <mat-radio-button
          (click)="handleRadioClick(formPosition.Fifth)"
          [value]="field?.name + formPosition.Fifth"
          (keydown)="handleRadioClick(formPosition.Fifth)"
        ></mat-radio-button>
      </mat-radio-group>
      <ah-asset-field-input
        [autoFocus]="autoFocus"
        [autoSize]="autoSize"
        (change)="onChangeFifth($event)"
        [controlName]="field?.canonical_name + formPosition.Fifth"
            [disabled]="
                !enabledFieldTypes.includes(field?.type) ||
                disabledFields.includes(field?.canonical_name) ||
                !radioFive
            "
        [field]="field"
        [filter]="filter"
        [fullWidth]="true"
        [group]="group"
            [options]="
                isPicklistField(field)
                    ? [makePicklistOption(field, formPosition.Fifth)]
                    : []
            "
        [placeholder]="placeholder"
        class="full-width-input-padding"
      ></ah-asset-field-input>
      <div class="checkbox-with-info">
        @if (field.canonical_name === 'cost') {
          <mat-checkbox
            class="sum-cost-checkbox"
            [checked]="sumTotalCostSelected"
            [disabled]="disableSumTotalCost"
            (change)="onSelectRowCheckbox($event)"
            >
            <span class="total-sum-label">SUM TOTAL COST</span>
          </mat-checkbox>
        }
        @if (field.canonical_name === 'cost' && disableSumTotalCost) {
          <mat-icon
            [matTooltip]="tooltipText"
            matTooltipPosition="right"
            class="info-icon"
            aria-label="Info"
            >
            info
          </mat-icon>
        }
      </div>
    </div>
  }
</div>
